import { render, staticRenderFns } from "./FacebookAppAccess.vue?vue&type=template&id=7b2a749e"
import script from "./FacebookAppAccess.vue?vue&type=script&lang=js"
export * from "./FacebookAppAccess.vue?vue&type=script&lang=js"
import style0 from "./FacebookAppAccess.vue?vue&type=style&index=0&id=7b2a749e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports